import { Result, backendApi } from "./backendApi";
import { LocaleModel } from "./drawingApi";

export enum HandDriveModel {
  LeftHandDrive = 1,
  RightHandDrive = 2,
}

export enum RescueSheetLicenseModel {
  RDW = 1,
  RSA = 2,
  Lite = 3,
}

class GetClassicRescueSheetRequest {
  constructor(
    public vehicleFileNumber: string,
    public loadFromDrawing: boolean,
    public recId: number | undefined,
    public componentString: string | undefined,
    public locale: LocaleModel,
    public handDrive: HandDriveModel | undefined,
    public license: RescueSheetLicenseModel,
    public width: number,
    public height: number,
    public darkMode: boolean,
    public origin: string | undefined,
    public uniqueId: string | undefined,
  ) {}
}

class GetClassicRescueSheetResponse {
  constructor(public svg: string) {}
}

export const rescueSheetApi = {
  async getClassicRescueSheet(
    vehicleFileNumber: string,
    loadFromDrawing: boolean,
    recId: number | undefined,
    componentString: string | undefined,
    locale: LocaleModel,
    handDrive: HandDriveModel | undefined,
    license: RescueSheetLicenseModel,
    width: number,
    height: number,
    darkMode: boolean,
    origin: string,
    uniqueId: string,
  ): Promise<Result<string>> {
    const result =
      await backendApi.sendAndGetResponseAsync<GetClassicRescueSheetResponse>(
        "GetClassicRescueSheet",
        new GetClassicRescueSheetRequest(
          vehicleFileNumber,
          loadFromDrawing,
          recId,
          componentString,
          locale,
          handDrive,
          license,
          width,
          height,
          darkMode,
          origin,
          uniqueId,
        ),
      );

    if (result.ok) return { ok: true, value: result.value.svg };

    return result;
  },
};
